/* eslint-disable */
import { useMemo } from "react"
import { useQuery } from "@tanstack/react-query"

import type { Token } from "@/domains/core"
import { defaultTokenSort } from "@/domains/library"

import type { ApiService } from "../api-service"

type UseTokensProps = {
  apiService: ApiService
  refreshInterval?: number
}

/**
 * useTokens is the token list only, please see useTokensWithBalances if you want
 * - native token balance
 * - injected usd value from balance & priceUsd
 *
 * @param param0
 * @returns
 */
export const useTokens = ({ apiService, refreshInterval }: UseTokensProps) => {
  const queryKey = ["api", "tokens"]

  const tokensQuery = useQuery({
    queryKey,
    queryFn: async () => {
      let tokens = []
      const tokensHash = (await apiService.getTokens()) as any
      tokens = Object.values(tokensHash) as Array<Token>
      tokens.forEach((token) => {
        token.balance = "0"
        token.balanceUsdValue = 0
      })
      tokens.sort(defaultTokenSort)
      return tokens
    },
    refetchInterval: 1000 * (refreshInterval ?? 30),
  })

  const tokens = useMemo(() => {
    return tokensQuery.data ?? []
  }, [tokensQuery.data])

  return { tokensQuery, tokens }
}
